var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "资金变动详情",
            visible: _vm.dialogFormVisible,
            modal: false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
            close: _vm.close,
          },
        },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.form, "label-width": "120px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "变更类型：" } },
                [
                  _c("el-input", {
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.form.changeTypeDesc,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "changeTypeDesc", $$v)
                      },
                      expression: "form.changeTypeDesc",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "日志：" } },
                [
                  _c("el-input", {
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.form.logRecord,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "logRecord", $$v)
                      },
                      expression: "form.logRecord",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("el-form-item", { attrs: { label: "记录凭证：" } }, [
                _vm.form.extra && _vm.form.extra.length > 0
                  ? _c(
                      "div",
                      _vm._l(_vm.form.extra, function (item) {
                        return _c("el-image", {
                          key: item,
                          staticStyle: {
                            width: "100px",
                            height: "100px",
                            "margin-right": "5px",
                          },
                          attrs: { src: item },
                        })
                      }),
                      1
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "备注：" } },
                [
                  _c("el-input", {
                    attrs: { type: "textarea", disabled: "" },
                    model: {
                      value: _vm.form.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "remark", $$v)
                      },
                      expression: "form.remark",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("el-form-item", { attrs: { label: "操作时间：" } }, [
                _vm._v(" " + _vm._s(_vm.form.updatedAt) + " "),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }